import {
  call,
  put,
} from 'redux-saga/effects';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  LYNX_TENANT,
  NOTIFICATION,
  LOADING, CLOVER_SYNC,
} from '../actionTypes';

const fetchLynxTenantDetails = async (params) => (
  axiosAuthInstance.get(
    `${API_END_POINTS.LYNX_TENANT_DETAIL}?page=${params.pageNum}&size=${params.size}&sortby=${params.sortBy}&direction=${params.direction}`,
  )
);

const fetchInternalLynxTenantDetails = async (params) => (
  axiosAuthInstance.get(
    `${API_END_POINTS.INTERNAL_LYNX_TENANT_DETAIL}?page=${params.pageNum}&size=${params.size}&sortby=${params.sortBy}&direction=${params.direction}`,
  )
);

const addInternalLynxTenantDetails = async (payload) => (
  axiosAuthInstance.post(`${API_END_POINTS.INTERNAL_LYNX_TENANT_DETAIL}`, payload.params)
);

const updateInternalLynxTenantDetails = async (payload) => (
  axiosAuthInstance.patch(`${API_END_POINTS.INTERNAL_LYNX_TENANT_DETAIL}/${payload.gid}`, payload.params)
);

const deleteInternalLynxTenantDetails = async (payload) => (
  axiosAuthInstance.delete(`${API_END_POINTS.INTERNAL_LYNX_TENANT_DETAIL}/${payload.gid}`)
);

export function* fetchTenantDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data } = yield call(fetchLynxTenantDetails, {
      sortBy: action.payload?.sortBy && action.payload?.sortBy !== '' ? action.payload.sortBy : 'createdAt',
      size: 10,
      pageNum: action.payload?.pageNum && action.payload?.pageNum !== '' ? action.payload.pageNum : '1',
      direction: action.payload?.direction && action.payload?.direction !== '' ? action.payload.direction : 'DESC',
    });
    yield put({
      type: LYNX_TENANT.SUCCESS_LYNX_TENANT_DETAILS,
      payload: data?.entity,
    });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
      });
      yield put({
        type: LYNX_TENANT.SUCCESS_LYNX_TENANT_DETAILS,
        payload: [],
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({ type: LOADING.UNSET });
  }
}

export function* fetchInternalTenantDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data } = yield call(fetchInternalLynxTenantDetails, {
      sortBy: action.payload?.sortBy && action.payload?.sortBy !== '' ? action.payload.sortBy : 'createdAt',
      size: 10,
      pageNum: action.payload?.pageNum && action.payload?.pageNum !== '' ? action.payload.pageNum : '1',
      direction: action.payload?.direction && action.payload?.direction !== '' ? action.payload.direction : 'DESC',
    });
    yield put({
      type: LYNX_TENANT.SUCCESS_LYNX_TENANT_DETAILS,
      payload: data?.entity,
    });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
      });
      yield put({
        type: LYNX_TENANT.SUCCESS_LYNX_TENANT_DETAILS,
        payload: [],
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({ type: LOADING.UNSET });
  }
}

export function* addTenantDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    yield put({ type: LOADING.VALIDATING });
    yield call(addInternalLynxTenantDetails, action.payload);
    const { data: { entity } } = yield call(fetchInternalLynxTenantDetails, action.payload);
    yield put({ type: LYNX_TENANT.SUCCESS_LYNX_TENANT_DETAILS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: 'Lynx Tenant Detail added successfully',
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({ type: LOADING.UNSET });
  }
}

export function* updateTenantDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    yield put({ type: LOADING.VALIDATING });
    yield call(updateInternalLynxTenantDetails, action.payload);
    const { data: { entity } } = yield call(fetchInternalLynxTenantDetails, action.payload);
    yield put({ type: LYNX_TENANT.SUCCESS_LYNX_TENANT_DETAILS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: 'Lynx Tenant Detail updated successfully',
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({ type: LOADING.UNSET });
  }
}

export function* deleteTenantDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    yield put({ type: LOADING.VALIDATING });
    yield call(deleteInternalLynxTenantDetails, action.payload);
    const { data: { entity } } = yield call(fetchInternalLynxTenantDetails, action.payload);
    yield put({ type: LYNX_TENANT.SUCCESS_LYNX_TENANT_DETAILS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: 'Lynx Tenant Detail deleted successfully',
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response?.data ? e.response.data?.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({ type: LOADING.UNSET });
  }
}
